import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const getRoleApi = createAsyncThunk(
    'auth/getRoles',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.adminAction("roles_permissions/roles", 1), { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const initialState = { result: [], loading: false, error: null, message: "", total: 0 }
const getRoleSlice = createSlice({
    name: 'getRole',
    initialState,
    reducers: {
        resetRoleList: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(getRoleApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(getRoleApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(getRoleApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const { resetRoleList } = getRoleSlice.actions
export const getRoleReducer = getRoleSlice.reducer
